import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import Config from '../configs'

export default {
	data () {
		return {
			tips: false,
			tipsauto: false,
			btnNum: 2,
			tipsFont: '',
			msg: [],
			deviceHeight: this.$root.deviceHeight,
			transitionName: 'page-next',
			companyInfo: {},
			sec: 1500,
			config: Config
		}
	},
	components: {
		'tips': Tips,
		'tips-auto': TipsAuto
	},
	created () {
		this.$http.get('/cldEdi/business/getCompany').then(response => {
			this.companyInfo = response.body.data
		}, (response) => {
			var self = this
			self.tipsauto = true
			self.tipsFont = '服务中断，稍后请重试！'
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		})
	},
	methods: {
		onConfirm (msg) {
			this.tips = true
			this.tipsFont = '确定要退出吗？'
		},
		tipStatus (msg) {
			this.tips = false
			this.msg = msg
			this.logOut()
		},
		logOut () {
			if (this.msg[1]) {
				this.tips = false
				this.$http.get('/cldEdi/business/logOut').then((response) => {
					if (response.body.result) {
						this.$router.push('/')
					}
				})
			} else {
				return false
			}
		}
	},
	computed: {
		logo () {
			return '../' + this.config.mylogo
		}
	}
}



// WEBPACK FOOTER //
// ./src/pages/My.js